<template>
  <div class="page">
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#">{{ $t("sales") }}</a>
          </li>
          <li>-</li>
          <li>
            <a href="#">{{ $t("offer") }} {{ $t("price") }}</a>
          </li>
          <li>-</li>
          <li>
            <a class="active" href="#">
              {{ $t("offer") }} {{ $t("price") }} - QTE-{{ alldata2.qid }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="head-option">
      <ul>
        <!-- <li>
              <a href="#" class="btn-download">
                <span class="text">Download PDF</span>
              </a>
            </li> -->
        <li>
          <router-link to="/AdminDashboard/OfferPrice" class="btn-download">
            <span class="text">
              <i class="bi bi-arrow-left-square-fill"></i>
              {{ $t("back") }}</span
            >
          </router-link>
        </li>
      </ul>
    </div>
    <div class="main">
      <div class="head">
        <h3>{{ $t("offer") }} {{ $t("price") }} - QTE-{{ alldata2.qid }}</h3>
      </div>
      <div class="body">
        <div class="part1">
          <div class="part11">
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
                >{{ $t("number") }}
              </label>
              <div class="col-sm-7">
                <div class="col-sm-7">QTE-{{ alldata2.qid }}</div>
              </div>
            </div>
            <!--  -->
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
                >{{ $t("date") }}
              </label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.due }}
                </div>
              </div>
            </div>
            <!--  -->
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
                >{{ $t("description") }}
              </label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.description }}
                </div>
              </div>
            </div>
            <!--  -->
          </div>
          <div class="part12">
            <h4>{{ $t("data") }} {{ $t("customer") }}</h4>

            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("name") }}
              </label>
              <div class="col-sm-7">
                {{ alldata2.cname }}
              </div>
            </div>
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("mobile") }}
              </label>
              <div class="col-sm-7">
                {{ alldata2.cmobile }}
              </div>
            </div>
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("email") }}
              </label>
              <div class="col-sm-7">
                {{ alldata2.cmail }}
              </div>
            </div>
            <div class="row mb-2">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                {{ $t("tax") }}
              </label>
              <div class="col-sm-7">
                {{ alldata2.ctax }}
              </div>
            </div>
          </div>
        </div>
        <div class="part2">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th style="width: 12%">{{ $t("product") }}</th>
                <th>{{ $t("description") }}</th>
                <th style="width: 10%">{{ $t("quantity") }}</th>
                <th style="width: 10%">{{ $t("unit type") }}</th>
                <th>{{ $t("price") }}</th>
                <th>{{ $t("total") }} {{ $t("befor") }} {{ $t("discount") }}</th>
                <th>{{ $t("discount") }}</th>
                <th>{{ $t("total") }} {{ $t("befor") }} {{ $t("tax") }}</th>
                <th>{{ $t("tax") }}</th>
                <th>{{ $t("amount") }} {{ $t("tax") }}</th>
                <th>{{ $t("total") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, id) in details" :key="value">
                <td>{{ id + 1 }}</td>
                <td>{{ value.pronamear }}</td>
                <td>
                  {{ value.description }}
                </td>
                <td>
                  {{ value.quantity }}
                </td>
                <td>{{ value.unittype }}</td>
                <td>{{ value.salep }}</td>
                <td>{{ Number(value.salep * value.quantity).toFixed(2) }}</td>
                <td>{{ value.discount }} %</td>
                <td>{{ Number(value.tbt).toFixed(2) }}</td>
                <td>{{ value.tax }} %</td>
                <td>{{ Number(value.taxamount).toFixed(2) }}</td>
                <td>{{ Number(value.total).toFixed(2) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="7"></td>
                <td>{{ $t("total") }}</td>
                <td>{{ Number(alldata2.tbt).toFixed(2) }}</td>
                <td></td>
                <td>{{ Number(alldata2.tax).toFixed(2) }}</td>
                <td>{{ Number(alldata2.tat).toFixed(2) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="row mb-2">
          <label
            for="inputEmail3"
            class="col-sm-1 col-form-label-sm"
            v-if="alldata2.branch"
            >{{ $t("branch") }}
          </label>
          <div class="col-sm-2">
            <div class="form-control" id="exampleFormControlTextarea1">
              {{ alldata2.branch }}
            </div>
          </div>
          <label
            for="inputEmail3"
            class="col-sm-1 col-form-label-sm"
            v-if="alldata2.project"
            >{{ $t("project") }}
          </label>
          <div class="col-sm-2" v-if="alldata2.project">
            <div class="form-control" id="exampleFormControlTextarea1">
              {{ alldata2.project }}
            </div>
          </div>
          <label
            for="inputEmail3"
            class="col-sm-1 col-form-label-sm"
            v-if="alldata2.task"
            >{{ $t("task") }}
          </label>
          <div class="col-sm-2" v-if="alldata2.task">
            <div class="form-control" id="exampleFormControlTextarea1">
              {{ alldata2.task }}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <label for="inputEmail3" class="col-sm-1 col-form-label-sm"
            >{{ $t("notes") }}
          </label>
          <div class="col-sm-5">
            <div class="form-control" id="exampleFormControlTextarea1">
              {{ alldata2.notes }}
            </div>
          </div>
        </div>

        <hr />
        <div class="user">
          <i class="bi bi-eye-fill"></i> &nbsp; {{ $t("created") }}
          {{ $t("by") }} : {{ alldata2.username }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.date }} - {{ $t("time") }} :
            {{ alldata2.time }}
          </div>
        </div>
        <div class="user" v-if="alldata2.review == 'confirmed'">
          <i class="bi bi-eye-fill"></i> &nbsp; {{ $t("confirmed") }}
          {{ $t("by") }} : {{ alldata2.reviewusername }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.reviewdate }} - {{ $t("time") }} :
            {{ alldata2.reviewtime }}
          </div>
        </div>
        <div class="user" v-if="alldata2.review == 'cancel'">
          <i class="bi bi-eye-fill"></i> &nbsp; {{ $t("cancel") }}
          {{ $t("by") }} : {{ alldata2.reviewusername }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.reviewdate }} - {{ $t("time") }} :
            {{ alldata2.reviewtime }}
          </div>
        </div>
      </div>
      <br />
      <div class="buttom">
        <button
          class="btn btn-success"
          type="submit"
          @click="confirm"
          v-if="alldata2.review == 'waiting'"
        >
          <i class="bi bi-file-check-fill"></i> {{ $t("confirm") }}
        </button>
        <button class="btn btn-primary" type="submit" @click="print">
          <i class="bi bi-printer-fill"></i> {{ $t("printe") }}
        </button>
        <button class="btn btn-primary" type="submit" @click="pdf">
          <i class="bi bi-filetype-pdf"></i> {{ $t("PDF") }}
        </button>
        <button class="btn btn-dark" type="submit" @click="back">
          {{ $t("cancel") }}
        </button>
      </div>
    </div>
    <!-- <div
      id="main"
      style="padding: 2%; border: 2px solid black; margin: 2%; display: none"
    >
      <div :style="{ direction: css.EN }">
        <img
          :src="this.url"
          crossorigin="anonymous"
          :style="{ float: css.xdirn, width: '40%' }"
        />
        <h3>{{ $t("offer") }} {{ $t("price") }}</h3>

        <br />
        {{ $t("number") }} : QTE-{{ alldata2.qid }}
        &nbsp;&nbsp;&nbsp;&nbsp;
        {{ $t("date") }} :
        {{ alldata2.due }}

        <div class="part1">
       
            <div>
                <h5>{{ this.$store.state.cnum[0].cname }}</h5>
                <br />
                 العنوان الوطني :
                {{ this.$store.state.cnum[0].caddress }}
                <br />
                 رقم الهاتف - الايميل:
                {{ this.$store.state.cnum[0].bankinfo }}
                <br />
                رقم تسجيل ضريبة القيمة المضافة :
                {{ this.$store.state.cnum[0].taxnum }}
            </div>
        </div>
        <div class="part1" style="clear: both">
          <br />
          <div>
            <h4>{{ $t("data") }} {{ $t("customer") }}</h4>
            <div style="padding: 2%">
              {{ $t("name") }} :
              {{ alldata2.cname }}
              <br />
              {{ $t("mobile") }} :
              {{ alldata2.cmobile }}
              <br />
              {{ $t("email") }} :
              {{ alldata2.cmail }}
              <br />
              {{ $t("tax") }} :
              {{ alldata2.ctax }}
            </div>
            {{ $t("description") }} :
            {{ alldata2.description }}
          </div>
        </div>
        <hr />
        <br />
        <div>
          <table style="width: 100%; text-align: center; font-size: smaller">
            <thead>
              <tr style="border: 0.5px solid black; height: 40px">
                <th style="border: 0.5px solid black">#</th>
                <th style="width: 12%; border: 0.5px solid black">
                  {{ $t("product") }}
                </th>
            
                <th style="width: 10%; border: 0.5px solid black">
                  {{ $t("quantity") }}
                </th>
                <th style="width: 10%; border: 0.5px solid black">
                  {{ $t("unit type") }}
                </th>
                <th style="border: 0.5px solid black">{{ $t("price") }}</th>
                <th style="border: 0.5px solid black">{{ $t("total") }} {{ $t("befor") }} {{ $t("discount") }}</th>
                <th style="border: 0.5px solid black">{{ $t("discount") }}</th>
                <th style="border: 0.5px solid black">
                  {{ $t("total") }} {{ $t("befor") }} {{ $t("tax") }}
                </th>
                <th style="border: 0.5px solid black">{{ $t("tax") }}</th>
      
                <th style="border: 0.5px solid black">{{ $t("total") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, id) in details"
                :key="value"
                style="height: 40px"
              >
                <td style="border: 0.5px solid black">{{ id + 1 }}</td>
                <td style="border: 0.5px solid black">{{ value.pronamear }}</td>

                <td style="border: 0.5px solid black">
                  {{ value.quantity }}
                </td>
                <td style="border: 0.5px solid black">{{ value.unittype }}</td>
                <td style="border: 0.5px solid black">{{ value.salep }}</td>
                <td style="border: 0.5px solid black">{{ Number(value.salep * value.quantity).toFixed(2) }}</td>
                <td style="border: 0.5px solid black">
                  {{ value.discount }} %
                </td>
                <td style="border: 0.5px solid black">{{ Number(value.tbt).toFixed(2) }}</td>
                <td style="border: 0.5px solid black">{{ Number(value.tax).toFixed(2) }} %</td>

                <td style="border: 0.5px solid black">{{ Number(value.total).toFixed(2) }}</td>
              </tr>
            </tbody>

            <tfoot>

              <tr style="height: 40px">
                <td colspan="8"></td>
                <td>الاجمالى قبل الخصم</td>
                <td style="border: 0.5px solid black">{{ Number(totalafterdis).toFixed(2) }}</td>
              </tr>
              <tr style="height: 40px">
                <td colspan="8"></td>
                <td>مبلغ  الخصم</td>
                <td style="border: 0.5px solid black">{{ Number(totalafterdis - alldata2.tbt).toFixed(2) }}</td>
              </tr>
              <tr style="height: 40px">
                <td colspan="8"></td>
                <td>الاجمالى </td>
                <td style="border: 0.5px solid black">{{ Number(alldata2.tbt).toFixed(2) }}</td>
              </tr>
              <tr style="height: 40px">
                <td colspan="8"></td>
                <td>ضريبة القيمة المضافة </td>
                <td style="border: 0.5px solid black">{{ Number(alldata2.tat-alldata2.tbt).toFixed(2) }}</td>
              </tr>
              <tr style="height: 40px">
                <td colspan="8"></td>
                <td>الاجمالى شامل ضريبة القيمة المضافة</td>
                <td style="border: 0.5px solid black">{{ Number(alldata2.tat).toFixed(2) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <hr />

        {{ $t("notes") }} :
        {{ alldata2.notes }}
        <hr />
      </div>
    </div> -->
  <div id="main" style="padding: 40px; direction: rtl; font-family: 'Arial', sans-serif; background: white; color: black; display: none;">
  <!-- Company Header -->
<!-- Company Header: Logo Left, Details Right -->
<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; border-bottom: 2px solid #000; padding-bottom: 20px; direction: ltr;">
  <!-- Logo on the Left -->
  <div style="flex: 0 0 auto;">
    <img :src="this.url" crossorigin="anonymous" style="height: 100px; max-width: 200px; object-fit: contain;" />
  </div>

  <!-- Company Details on the Right -->
  <div style="flex: 1; text-align: right; margin-right: 20px;">
    <h2 style="margin: 0 0 10px 0; font-size: 24px;">{{ this.$store.state.cnum[0].cname }}</h2>
    <p style="margin: 5px 0; font-size: 14px; line-height: 1.6;">
      العنوان الوطني: {{ this.$store.state.cnum[0].caddress }}<br>
      الهاتف والإيميل: {{ this.$store.state.cnum[0].bankinfo }}<br>
      رقم تسجيل ضريبة القيمة المضافة: {{ this.$store.state.cnum[0].taxnum }}
    </p>
  </div>
</div>

  <!-- Title -->
  <h3 style="text-align: center; margin: 30px 0;">عرض سعر / Quotation</h3>

  <!-- Info Grid -->
  <table style="width: 100%; margin-bottom: 40px; font-size: 12px;">
    <tr>
      <td style="width: 50%; vertical-align: top;">
        <strong>رقم العرض / Quotation No.:</strong> QTE-{{ alldata2.qid }}<br>
        <strong>التاريخ / Date:</strong> {{ alldata2.due }}<br>
        <strong>تاريخ الانتهاء / Expiry Date:</strong> {{ alldata2.expiry || '30 يوم' }}
      </td>
      <td style="width: 50%; vertical-align: top; text-align: left; direction: ltr;">
        <strong>To / إلى:</strong><br>
        <h2>{{ alldata2.cname }}</h2><br>
        {{ alldata2.cmobile }}<br>
        {{ alldata2.cmail }}
      </td>
    </tr>
  </table>

  <!-- Items Table -->
  <table style="width: 100%; border-collapse: collapse; direction: rtl; text-align: right; margin-bottom: 40px; font-size: 14px;">
    <thead style="background: #f0f0f0;">
      <tr>
        <th style="border: 1px solid #000; padding: 10px;">#</th>
        <th style="border: 1px solid #000; padding: 10px;">المنتج / Product</th>
        <th style="border: 1px solid #000; padding: 10px;">الكمية / Qty</th>
        <th style="border: 1px solid #000; padding: 10px;">الوحدة / Unit</th>
        <th style="border: 1px solid #000; padding: 10px;">سعر الوحدة / Unit Price</th>
        <th style="border: 1px solid #000; padding: 10px;">الإجمالي / Total</th>
        <th style="border: 1px solid #000; padding: 10px;"> نسبة الخصم </th>
        <th style="border: 1px solid #000; padding: 10px;"> الإجمالي بعد الخصم </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in details" :key="index">
        <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ index + 1 }}</td>
        <td style="border: 1px solid #000; padding: 8px;">{{ item.pronamear }}</td>
        <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ item.quantity }}</td>
        <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ item.unittype }}</td>
        <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ Number(item.salep).toFixed(2) }} ر.س</td>
        <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ Number(item.salep * item.quantity).toFixed(2) }} ر.س</td>
        <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ Number(item.discount).toFixed(2) }}</td>
         <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ Number(item.tbt).toFixed(2) }} ر.س</td>
      </tr>
    </tbody>
  </table>

  <!-- Totals -->
<div style="float: left; width: 40%; direction: rtl; text-align: right; border: 1px solid #000; padding: 15px; margin-left: 20px;">    
        <div style="display: flex; justify-content: space-between; margin: 10px 0;">
      <span>الإجمالي قبل الخصم</span>
      <span>{{ Number(totalafterdis).toFixed(2) }} ر.س</span>
    </div>
      <div style="display: flex; justify-content: space-between; margin: 10px 0;">
      <span> مبلغ الخصم</span>
      <span>{{ Number(totalafterdis - alldata2.tbt).toFixed(2) }} ر.س</span>
    </div>
    <div style="display: flex; justify-content: space-between; margin: 10px 0;">
      <span>الإجمالي قبل الضريبة / Subtotal</span>
      <span>{{ Number(alldata2.tbt).toFixed(2) }} ر.س</span>
    </div>
    <div style="display: flex; justify-content: space-between; margin: 10px 0;">
      <span>ضريبة القيمة المضافة (15%) / VAT</span>
      <span>{{ Number(alldata2.tat - alldata2.tbt).toFixed(2) }} ر.س</span>
    </div>
    <div style="display: flex; justify-content: space-between; margin: 15px 0; font-weight: bold; font-size: 18px; border-top: 2px solid #000; padding-top: 10px;">
      <span>الإجمالي النهائي / Grand Total</span>
      <span>{{ Number(alldata2.tat).toFixed(2) }} ر.س</span>
    </div>
  </div>
  <div style="clear: both;"></div>

  <!-- Notes & Stamp -->
  <div >
    <p><strong>ملاحظات / Notes:</strong> {{ alldata2.notes || 'لا توجد ملاحظات' }}</p>
    <!-- <div style="display: flex; justify-content: space-between; margin-top: 40px;">
      <div style="border: 2px dashed #000; width: 200px; height: 150px; text-align: center; line-height: 150px;">
        الختم / Company Stamp
      </div>
      <div>التوقيع / Authorized Signature ____________________</div>
    </div> -->
  </div>
</div>
  
  </div>
</template>
<script>
import store from "@/store";
// import useValidate from "@vuelidate/core";
// import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import html2pdf from "html2pdf.js";
export default {
  async mounted() {
    const data2 = await axios.get(
      `/data/odderpriceview/${this.$route.params.id}`
    );
    if (data2.status == 200) {
      const data = data2.data.data[0];
      this.alldata2 = data;
      this.details = JSON.parse(this.alldata2.details);
      for (let x = 0; x < this.details.length; x++) {
        const element = this.details[x];
        element.afterdis = Number(element.salep * element.quantity).toFixed(2)
      }
      this.totaldpt = this.details.reduce(
        (acc, array) => acc + Number(array.dpt),
        0
      );
      this.totalcrd = this.details.reduce(
        (acc, array) => acc + Number(array.crd),
        0
      );
      this.totalafterdis = this.details.reduce(
        (acc, array) => acc + Number(array.afterdis),
        0
      );
      this.url = store.state.imgurl + `/journalentry/`;
    }
    this.url =
      store.state.imgurl + `/clogo/${this.$store.state.cnum[0].cnum}.png`;
  },
  props: ["css"],
  data() {
    return {
      alldata2: "",
      details: [],
      fileurl: [],
      url: "",
      totalafterdis:0
    };
  },
  methods: {
    confirm() {
      Swal.fire({
        title:
          this.$t("confirm") +
          " " +
          this.$t("offer") +
          " " +
          this.$t("price") +
          " - " +
          this.alldata2.qid,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("confirm"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const action = await axios.post("/data/confirmofferprice", {
            id: this.alldata2.qid,
            username: store.state.randp.username,
          });
          if (action.status == 200) {
            Swal.fire(
              this.$t("done") +
                " " +
                this.$t("confirm") +
                " " +
                this.$t("offer") +
                " " +
                this.$t("price") +
                " - " +
                this.alldata2.id
            );
            this.redirectTo({ val: "OfferPrice" });
          }
        }
      });
    },
    pdf() {
      html2pdf(document.getElementById("main").innerHTML, {
        margin: 0.2,
        filename: `QTE-${this.alldata2.qid}.pdf`,
        image: { type: "jpeg", quality: 100 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },
    print() {
      this.$htmlToPaper("main");
    },
    print2() {
      var divElements = document.getElementById("main").innerHTML;

      var newWindow = window.print();

      newWindow.document.write(
        "<html><head><title>ESLAM</title></head><body>" +
          divElements +
          "</body>"
      );
    },
    ...mapActions(["redirectTo"]),
  },
};
</script>
<style lang="scss" scoped>
.page {
  direction: v-bind("css.EN");
  padding: 1%;
}
a {
  text-decoration: none;
}
.head-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-gap: 16px;
  flex-wrap: wrap;
}
.head-title .left h1 {
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #342e37;
}
.head-title .left .breadcrumb {
  display: flex;
  align-items: center;
  grid-gap: 16px;
}
.head-title .left .breadcrumb li {
  color: #342e37;
}
.head-title .left .breadcrumb li a {
  color: #aaaaaa;
  pointer-events: none;
}
.head-title .left .breadcrumb li a.active {
  color:  v-bind("css.color");
  pointer-events: unset;
}

.head-option {
  direction: v-bind("css.AR");
  width: 100%;
  // border: #342e37 1px solid;
  padding: 0.5%;
}
.head-option ul li {
  display: inline;
  padding: 0.5%;
}
.head-option .btn-download {
  width: 20%;
  padding: 0.5%;
  border-radius: 5px;
  background:  v-bind("css.color");
  color: #f9f9f9;
}
.main .head {
  border-top:  v-bind("css.color") 5px solid;
  background:  v-bind("css.color");
  color: #f9f9f9;
  border-radius: 3px 3px 0px 0px;
  padding: 0.25%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.main .body {
  background: v-bind("css.light");
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 1%;
  //   display: flex;
}
.main .body .part1 {
  background: v-bind("css.light");
  //   box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 1%;
  display: flex;
  width: 100%;
}
.main .body .part11 {
  width: 50%;
}
.main .body .part12 {
  width: 40%;
  //   border: solid rgba(0, 0, 0, 0.274) 00.5px;
}
.main .body .part2 {
  background: v-bind("css.light");
  padding: 1%;
  width: 100%;
}
.options {
  height: 150px;
  margin: 1%;
  background-color: v-bind("css.light");
  color: v-bind("css.dark");
  padding: 2%;
  overflow-y: auto;
}
.options ul li {
  margin: 0.5%;
}
.options ul li:hover {
  color: white;
  background-color: black;
}
.buttom {
  text-align: center;
}
button {
  margin: 0.5%;
}
.user {
  width: 50%;
  // border: black solid 0.5px;
  padding: 1%;
  border-radius: 5px;
}
.udate {
  font-size: small;
  color: #3c91e6;
}
</style>
